/*
 *   Copyright (c) 2021 Sok Channy
 *   All rights reserved.
 */
// Copyright 2021 channysok
// 
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
// 
//     http://www.apache.org/licenses/LICENSE-2.0
// 
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.


import React, { useEffect, useCallback, useState} from 'react'
import { useDispatch, useSelector } from "react-redux"
import { Card, Form, Row, Col, InputGroup, Table, Button } from '@themesberg/react-bootstrap'
import { faPhone, faUser, faBarcode, faUserAlt, faAddressCard, faSave, faEdit, faBox} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import ReceiverAction from '../../core/redux/action/ReceiverAction'
import _, { get } from "lodash"
import { ApiSrc } from '../../resources/ApiSrc'
import Progress from "../../components/Progress"
import { GetResultObject, PostRequest } from '../../core/API'
import { CircleChartWidget } from '../../components/Widgets'

export default (props) => {

    const dispatch = useDispatch();
    const receiverRes = useSelector((state) => state.receiver);    
    const receiver = _.get(receiverRes, 'receiver', {})    

    const [firstName, setFirstName] = useState()
    const [lastName, setLastName] = useState()
    const [sex, setSex] = useState()
    const [phone, setPhone] = useState()
    const [wrongPhone, setWrongPhone] = useState()
    const [accountNo, setAccountNo] = useState()
    const [address, setAddress] = useState()
    const [countryCode, setCountryCode] = useState('855')
    const [postalCode, setPostalCode] = useState()
    const [expressId, setExpressId] = useState()          
    const [warehouseId, setWarehouseId] = useState()
    const [warehouseAccountNo, setWarehouseAccountNo] = useState()    
    const [progressValue, setProgressValue] = useState();

    const [statistic, setStatistic] = useState();

    const escFunction = useCallback((event) => {
      if(event.keyCode === 27) {        
        props.onClose && props.onClose()
      }
    }, [props]);
  
    useEffect(() => {
      document.addEventListener("keydown", escFunction, false);
      return () => {
        document.removeEventListener("keydown", escFunction, false);
      };
    }, [escFunction]);

    useEffect(()=>{
        getWarehouses()

        getStatistic()
    },[])

    const getWarehouses = () => {
        dispatch(ReceiverAction.getReceiverDetail({
            "input": {
              "id": _.get(props, 'id')
            },
            "token": "string"
        }))
    }

    const getStatistic = () => {
        PostRequest(ApiSrc.GET_WAYBILL_STATISTIC, {token: "", input: { userId: _.get(props, 'id')}}).then(result => {
            GetResultObject(result, 'data', 200, (data) => {
                const mapWaybillByStatus= _.groupBy(data, 'status')
                //mapWaybill[key] = mapWaybillByStatus
                const row = [
                    { 
                        id: 1, 
                        label: "Pending", 
                        value: mapWaybillByStatus['Pending'] ? mapWaybillByStatus['Pending'][0].count : 0 ,
                        color: "warning", 
                        icon: faBox 
                    },
                    { 
                        id: 1, 
                        label: "Warehouse", 
                        value: mapWaybillByStatus['Warehouse'] ? mapWaybillByStatus['Warehouse'][0].count : 0 ,
                        color: "primary", 
                        icon: faBox 
                    },
                    { 
                        id: 1, 
                        label: "Ready for Transit", 
                        value: mapWaybillByStatus['Ready for Transit'] ? mapWaybillByStatus['Ready for Transit'][0].count : 0 ,
                        color: "secondary", 
                        icon: faBox 
                    },
                    { 
                        id: 1, 
                        label: "Transit", 
                        value: mapWaybillByStatus['Transit'] ? mapWaybillByStatus['Transit'][0].count : 0 ,
                        color: "info", 
                        icon: faBox 
                    },
                    { 
                        id: 1, 
                        label: "Arrived", 
                        value: mapWaybillByStatus['Arrived'] ? mapWaybillByStatus['Arrived'][0].count : 0 ,
                        color: "success", 
                        icon: faBox 
                    },
                    { 
                        id: 1, 
                        label: "Received", 
                        value: mapWaybillByStatus['Received'] ? mapWaybillByStatus['Received'][0].count : 0 ,
                        color: "danger", 
                        icon: faBox 
                    },        
                ]
                setStatistic(row)
            })
        })
    }
    
    const onUpdate = () => {
        const body = {
            id: _.get(props, 'id'),
            expressId,
            firstName,
            lastName,
            sex,
            phone,
            address,
            countryCode,
            expressId,
            accountNo,
            joonaakFee:0,
        }

        setProgressValue(30)
        PostRequest(ApiSrc.UPDATE_RECEIVER, {input: {...body}, token: null}).then(result =>            
            GetResultObject(result, 'data', 200, (data) => {
                setProgressValue(100)
                dispatch(ReceiverAction.updateReceiverSuccess(data));                  
                let timer = setInterval(function(){ 
                    props.onClose && props.onClose(timer)
                }, 1000);
            })
        )
        //dispatch(ReceiverAction.updateReceiver({input: {...body}, token: null}));
        // props.onClose && props.onClose()
    }

    const onPhoneChange = (e) => {
        //(e)=>setPhone(e.target.value        
        var value = e.target.value        
        const reg = /^[1-9][0-9]\d{3}\d{3}/;        
        if (reg.test(value) === false) {   
            console.log(">reg false", value)         
            setPhone(value == "" ? undefined : value)
            setWrongPhone(value == "" ? undefined : "Invalid Phone")
            return false;
        } else {
            console.log(">reg true", value)
            setWrongPhone(undefined)
            setPhone(value)
            return true;
        }
    }

    return (
        <div>
            {
                progressValue !== undefined && (<Progress variant="success" label="Progress..." value={progressValue ?? 1} />)
            }
            <Card>
                <Card.Header>
                    <h6>User Detail</h6>
                </Card.Header>
                <Card.Body>
                    <Form>                        
                        <Row>
                            <Col xs={12} sm={6} xl={6}>
                                <Row>
                                    <Col>    
                                        <Col>
                                            <Form.Label>First Name</Form.Label>
                                        </Col>                            
                                        <Col>                                    
                                            <InputGroup>
                                                <InputGroup.Text >                                            
                                                    <FontAwesomeIcon icon={faUser} />
                                                </InputGroup.Text>
                                                <Form.Control autoFocus required type="text" 
                                                    onChange={(e)=>setFirstName(e.target.value)}
                                                    placeholder={_.get(receiver, 'firstName', "First Name")} />
                                            </InputGroup>
                                        </Col>
                                    </Col>                                                        
                                    <Col>                             
                                        <Col>
                                            <Form.Label>Last Name</Form.Label>
                                        </Col>                            
                                        <Col>
                                            <InputGroup>
                                                <InputGroup.Text >                                            
                                                    <FontAwesomeIcon icon={faUser} />
                                                </InputGroup.Text>
                                                <Form.Control autoFocus required type="text"                                                     
                                                    onChange={(e)=>setLastName(e.target.value)}
                                                    placeholder={_.get(receiver, 'lastName', "Last Name")} />
                                            </InputGroup>
                                        </Col>                                       
                                    </Col> 
                                </Row>
                                <Row>
                                    <Col>                                            
                                        <Form.Group className="mb-3">
                                        <Form.Label>Sex</Form.Label>
                                        <InputGroup>
                                            <Form.Select onChange={(e) => {                                                
                                                setSex(e.target.value ==  e.target.value == "--Select--" ? undefined : e.target.value)
                                            }}>
                                            <option>{_.get(receiver, 'sex') ? _.get(receiver, 'sex') : "--Select--"}</option>                                            
                                            <option>Male</option>
                                            <option>Female</option> 
                                            </Form.Select>                
                                        </InputGroup>
                                        </Form.Group>                                       
                                    </Col>                                                                                            
                                </Row>
                                <Row>
                                    <Col>    
                                        <Col>
                                            <Form.Label>Account No#</Form.Label>
                                        </Col>                            
                                        <Col>                                    
                                            <InputGroup>
                                                <InputGroup.Text >                                            
                                                    <FontAwesomeIcon icon={faBarcode} />
                                                </InputGroup.Text>
                                                <Form.Control autoFocus required type="text" 
                                                    //onChange={(e)=>setUsername(e.target.value)}                                                     
                                                    placeholder={_.get(receiver, 'accountNo', "Master account no")}/>                                                     
                                            </InputGroup>
                                        </Col>
                                    </Col>                                                                                            
                                </Row>
                                <Row>
                                    <Col xs={4} sm={4} xl={4}>
                                        <Form.Group className="mb-3">
                                        <Form.Label>Country Code</Form.Label>
                                        <InputGroup>
                                            <Form.Select onChange={(e) => {                                                
                                                setCountryCode(e.target.value == e.target.value)
                                            }}>
                                            <option>855</option>                                            
                                            </Form.Select>                
                                        </InputGroup>
                                        </Form.Group>                                        
                                    </Col>
                                    <Col xs={8} sm={8} xl={8}>
                                        <Col>
                                            <Form.Label>Phone Number</Form.Label>
                                        </Col>                            
                                        <Col>                                    
                                            <InputGroup>                                                
                                                <InputGroup.Text >                                            
                                                    <FontAwesomeIcon icon={faPhone} />
                                                </InputGroup.Text>
                                                <Form.Control autoFocus required type="number"
                                                    value={phone}
                                                    onChange={onPhoneChange}
                                                    placeholder={_.get(receiver, 'phone', "Phone")}/>
                                            </InputGroup>
                                        </Col>          
                                        <Col>
                                            <label className={"text-danger"}>{wrongPhone}</label>
                                        </Col>                                                                                                                      
                                    </Col>                                        
                                </Row>
                               
                            </Col>
                            <Col xs={12} sm={6} xl={6} className="mb-4">
                                {
                                    statistic && (
                                        <>                                        
                                            <CircleChartWidget
                                                title={`Services ${_.sumBy(statistic, 'value')}`}
                                                data={statistic}                                                     
                                            />                                            
                                        </>
                                    )
                                }
                            </Col>                                                                                 
                        </Row>
                    </Form>
                    <br/>
                    {
                        progressValue == undefined && (
                            <Form>
                                <Button onClick={onUpdate}><FontAwesomeIcon icon={faSave} /> Update</Button>
                            </Form>
                        )
                    }
                
                    
                </Card.Body>

                

                <Card.Header>
                    <h6>Warehouses</h6>
                </Card.Header>
                <Card.Body>
                    <Row>
                        <Col>
                            <Table responsive className="table-centered table-nowrap rounded">
                                <thead className="thead-light">
                                    <th>#</th>                                    
                                    <th  width={250}>Account No</th>
                                    <th>AAccount Name</th>
                                    <th>Country</th>
                                    <th>Country Code</th>
                                    <th>Zip Code</th>
                                    <th>Post Code</th>
                                    <th>Note</th>
                                </thead>    
                                <tbody>
                                    {
                                        _.get(receiver, 'warehouses', []) && _.get(receiver, 'warehouses', []).map((item, index) => {
                                            return <tr>
                                                <td>{index + 1}</td>                                                
                                                <td>
                                                {
                                                    warehouseId == _.get(item, 'id') && (
                                                        <InputGroup>
                                                            <InputGroup.Text > 
                                                                <FontAwesomeIcon icon={faSave} onClick={()=>{
                                                                    PostRequest(ApiSrc.UPDATE_RECEIVER_WAREHOUSE_ACCOUNT_NO, {
                                                                        input: {
                                                                            id: _.get(item, 'id'),
                                                                            accountNo: warehouseAccountNo
                                                                        }
                                                                    }).then(result => {
                                                                        GetResultObject(result, 'data', 200, (data, page) => {
                                                                            setWarehouseId(undefined)      
                                                                            getWarehouses()                                                                      
                                                                        })    
                                                                    })
                                                                    
                                                                }}/>                                                                                                       
                                                            </InputGroup.Text>
                                                            <Form.Control autoFocus required type="text" 
                                                                onChange={(e)=>setWarehouseAccountNo(e.target.value)}
                                                                placeholder={_.get(item, 'accountNo')}
                                                            />
                                                        </InputGroup>
                                                    )
                                                }
                                                {
                                                    warehouseId != _.get(item, 'id') && (
                                                        <div>
                                                        <Button 
                                                            onClick={()=>{
                                                                setWarehouseId(_.get(item, 'id'))
                                                                setWarehouseAccountNo(_.get(item, 'accountNo'))
                                                            }}
                                                            variant="transparent" 
                                                            size="sm" 
                                                            className="ms-3 mb-0 fs-10"><FontAwesomeIcon icon={faEdit}/></Button> {_.get(item, 'accountNo')}
                                                        </div>
                                                    )
                                                }
                                                
                                                </td>
                                                <td>{_.get(item, 'accountName')}</td>
                                                <td>{_.get(item, 'warehouse.country')}</td>
                                                <td>{_.get(item, 'warehouse.countryCode')}</td>
                                                <td>{_.get(item, 'warehouse.zipCode')}</td>
                                                <td>{_.get(item, 'warehouse.postCode')}</td>
                                                <td>{_.get(item, 'warehouse.note').replaceAll('account_no',_.get(item, 'accountName'))}</td>
                                            </tr>
                                        })
                                    }
                                </tbody>
                            </Table>
                        </Col>
                    </Row>
                </Card.Body>
            </Card>
            
        </div>
    )
}